import { render } from "./TalkRoomPost.vue?vue&type=template&id=7756e3b5&ts=true"
import script from "./TalkRoomPost.vue?vue&type=script&lang=ts&setup=true"
export * from "./TalkRoomPost.vue?vue&type=script&lang=ts&setup=true"

import "./TalkRoomPost.vue?vue&type=style&index=0&id=7756e3b5&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/talkRoom/TalkRoomPost.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7756e3b5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7756e3b5', __exports__)) {
    api.reload('7756e3b5', __exports__)
  }
  
  module.hot.accept("./TalkRoomPost.vue?vue&type=template&id=7756e3b5&ts=true", () => {
    api.rerender('7756e3b5', render)
  })

}


export default __exports__